import { useNavigate } from "react-router-dom";
import { useDeleteTenant, useGetTenant } from "../../features/tenant";
import { FiTrash } from "react-icons/fi";
import ModalConfirmationDelete from "../../components/ModalConfirmationDelete";
import { useState } from "react";

const TenantPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [id, setId] = useState("");
  const { tenant } = useGetTenant();
  const { Delete } = useDeleteTenant();
  const navigate = useNavigate();

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleConfirmDelete = () => {
    Delete(id);
    setIsModalOpen(false);
  };
  return (
    <>
      <div className="p-6">
        <div className="overflow-x-auto">
          <div className="flex justify-between mb-5">
            <h1 className="mt-2 mb-5 font-semibold text-xl text-gray-900">
              Tenant List
            </h1>
            <button
              type="button"
              onClick={() => navigate("/tenant/create")} // Navigate to user listing or another page
              className=" mt-6 text-xs px-3 bg-green-500 text-white font-medium rounded-md focus:outline-none focus:ring-2"
            >
              Create
            </button>
          </div>
          <table className="min-w-full bg-white rounded-lg shadow-md">
            <thead className="bg-blue-800 text-white">
              <tr>
                <th className="px-6 py-3 text-left text-sm font-medium">
                  Nama
                </th>
                <th className="px-6 py-3 text-left text-sm font-medium">
                  Category
                </th>
                <th className="px-6 py-3 text-left text-sm font-medium">
                  Address
                </th>
                <th className="px-6 py-3 text-left text-sm font-medium">
                  Action
                </th>
                {/* <th className="px-6 py-3 text-left text-sm font-medium">Code</th>
              <th className="px-6 py-3 text-left text-sm font-medium">Price</th>
              <th className="px-6 py-3 text-left text-sm font-medium">
                Description
              </th> */}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {tenant?.map((order, index) => (
                <tr key={index} className="hover:bg-gray-50">
                  <td className="px-6 py-4 text-sm text-gray-700">
                    {order?.name}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-700">
                    {order?.category}
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-700">
                    {order?.address}
                  </td>
                  <td
                    className="px-6 py-4 cursor-pointer text-sm text-gray-700"
                    onClick={() => {
                      setIsModalOpen(true);
                      setId(order?.id);
                    }}
                  >
                    <FiTrash />
                  </td>
                  {/* <td className="px-6 py-4 text-sm text-gray-700">
                  {order.name}
                </td>
                <td className="px-6 py-4 text-sm text-gray-700">
                  <NumberFormat value={order.name} prefix="Rp. " />
                </td>
                <td className="px-6 py-4 text-sm text-gray-700">
                  {order.name}
                </td> */}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <ModalConfirmationDelete
        isOpen={isModalOpen}
        title="Apakah Anda yakin akan Delete Tenant"
        onClose={handleCloseModal}
        onConfirm={handleConfirmDelete}
      />
    </>
  );
};

export default TenantPage;
